import { create } from "zustand";
import { persist } from "zustand/middleware";

interface OrgState {
  /** Organizacion activa del panel. */
  activeOrgId: string | null;
  setActiveOrg: (id: string | null) => void;
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
}

/**
 * La organizacion activa vive en el cliente, NO en el JWT.
 *
 * Meterla en `app_metadata` dejaria el token obsoleto hasta el siguiente
 * refresco: revocar a un empleado tardaria hasta una hora. Con el helper de
 * RLS consultando la tabla en cada peticion, la revocacion es inmediata.
 *
 * Este valor solo sirve para filtrar y para que las consultas usen los indices
 * compuestos. La barrera de seguridad sigue siendo RLS.
 */
export const useOrg = create<OrgState>()(
  persist(
    (set) => ({
      activeOrgId: null,
      setActiveOrg: (activeOrgId) => set({ activeOrgId }),
      sidebarCollapsed: false,
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
    }),
    { name: "synkro.org" },
  ),
);

export const useActiveOrgId = () => useOrg((s) => s.activeOrgId);
